import Button from "components/Button";
import React from "react";
import EditGreen from "icons/edit-green.svg";
import { useHistory } from "react-router-dom";

type Props = {
  valueMonth: any;
  valueOneTime: any;
  entityId: string;
};

const ShowPlans: React.FC<Props> = ({
  valueMonth,
  valueOneTime,
  entityId,
}): JSX.Element => {
  let history = useHistory();

  return (
    <div className="flex flex-row p-2 justify-between">
      <div className="flex flex-col">
        <div className="flex flex-row">
          <span
            className="text-xs"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: "#4F4F4F",
            }}
          >
            Active plans
          </span>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex flex-col mr-2">
            <div className="flex flex-row">
              <div className="w-2 h-2 bg-bt-green rounded-full mr-2 my-auto" />
              <div
                className="text-sm"
                style={{
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#4F4F4F",
                }}
              >
                Monthly Plan: ${valueMonth}
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-2">
            <div className="flex flex-row">
              <div className="w-2 h-2 bg-bt-green rounded-full mr-2 my-auto" />
              <div
                className="text-sm"
                style={{
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#4F4F4F",
                }}
              >
                Lifetime Plan: ${valueOneTime}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <Button
          label={"Edit"}
          className={`h-14 w-28 mr-2 text-base border border-bt-green text-bt-green rounded-full font-sora font-medium2`}
          iconLeft={EditGreen}
          onClick={() => {
            history.push(`/entity-management/${entityId}/edit`);
          }}
        />
      </div>
    </div>
  );
};

export default ShowPlans;
